/**
 * 深度克隆
 * @param {Object} sources 需要克隆的对象
 * @return {Object}
 */
export function deepClone(sources) {
  return JSON.parse(JSON.stringify(sources));
}

/**
 * 将对象序列化为字符串
 * @param {Object} sources 需要序列化的对象
 * @return {string}
 */
export function serialize(sources) {
  return JSON.stringify(sources);
}
